import {ActionEnum} from "../action.enum";
import {
  ChecklistTemplateEntryCondition
} from "../../models/checklist-template-entry/checklist-template-entry-condition.model";
import {ChecklistTemplateEntryRange} from "../../models/checklist-template-entry/checklist-template-entry-range.model";

export namespace ChecklistTemplateEntryConditionAction {

  export class Create {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_CONDITION_CREATE;
    constructor (public checklistTemplateEntryId: string) {}
  }

  export class Edit {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_CONDITION_EDIT;
    constructor (
      public checklistTemplateEntryId: string,
      public checklistTemplateEntryConditionId: string
    ) {}
  }

  export class Update {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_CONDITION_UPDATE;
    constructor (
      public checklistTemplateEntryCondition: Partial<ChecklistTemplateEntryCondition>
    ) {}
  }

  export class UpdateRange {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_CONDITION_UPDATE_RANGE;
    constructor (
      public checklistTemplateEntryRange: Partial<ChecklistTemplateEntryRange>
    ) {}
  }

  export class Save {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_CONDITION_SAVE;
  }

  export class Delete {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_CONDITION_DELETE;
  }

  export class ResetState {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_CONDITION_RESET_STATE;
  }
}
